export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-11.png?eb047bdf912107b40599bfe8bbddf7ab";